import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { Opportunity, OppStage } from '@core/models';

/**
 * Opportunities actions. The page requests a load; edits (upsert, delete, stage
 * change, next-step toggle) are session-only and update the slice in place.
 */
export const OpportunitiesPageActions = createActionGroup({
  source: 'Opportunities Page',
  events: {
    Entered: emptyProps(),
    Saved: props<{ opportunity: Opportunity }>(),
    Deleted: props<{ id: string }>(),
    'Stage Changed': props<{ id: string; stage: string }>(),
    'Step Toggled': props<{ id: string; stepId: string }>(),
    'Stages Changed': props<{ stages: OppStage[] }>(),
  },
});

export const OpportunitiesApiActions = createActionGroup({
  source: 'Opportunities API',
  events: {
    'Load Success': props<{ opportunities: Opportunity[]; stages: OppStage[] }>(),
    'Load Failure': props<{ error: string }>(),
  },
});
